import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { Action } from '../../actions';
import { openPricePackagesClientsModal } from '../../actions/pricePackagesClientsModal';
import {
    PricePackagesClientsListTooltipContainer,
    PricePackagesClientsListTooltipProps
} from '../../components/PricePackagesClientsListTooltip/PricePackagesClientsListTooltip';
import { GdStatusApprove } from '../../typings/graphql-grid';
import { State } from '../../typings/state';
import { TDispatchProps, TStateProps } from '../../typings/utils';

type StateProps = TStateProps<PricePackagesClientsListTooltipProps>;
type DispatchProps = TDispatchProps<PricePackagesClientsListTooltipProps>;

export type OwnProps = {
    clientIds?: string[];
    status: GdStatusApprove;
    id: number;
};

const mapStateToProps = (state: State, ownProps: OwnProps): StateProps => {
    return {
        clientIds: ownProps.clientIds || [],
        canAddClients: ownProps.status === GdStatusApprove.YES
    };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>, ownProps: OwnProps): DispatchProps => {
    const { id } = ownProps;

    return {
        onModalShow: () => {
            dispatch(openPricePackagesClientsModal(id));
        }
    };
};

const mergeProps = (stateProps: StateProps, dispatchProps: DispatchProps): PricePackagesClientsListTooltipProps => {
    return {
        ...stateProps,
        ...dispatchProps
    };
};

export const PricePackagesClientContainer = connect<
    StateProps,
    DispatchProps,
    OwnProps,
    PricePackagesClientsListTooltipProps
>(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(PricePackagesClientsListTooltipContainer);
